import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {OuterPagesGuardService} from '../../../guards/outer-pages-guard.service';
import {ContactComponent} from './contact.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.landingContact.pageInRouting,
    data: {data: PAGES_AND_PATHS.landingContact},
    component: ContactComponent,
    canActivate: [OuterPagesGuardService],
    loadChildren: () => import('./contact.module').then(m => m.ContactModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContactRoutingModule { }
